import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import { FilterTable } from 'gnos-tables'

import { LOCALE_PREFIX } from '../../constants'

import hocConnect from './hocConnect'
import './style.scss'
import CustomDate from '../../../../../../../../../../../components/CustomDate'

@hocConnect
@injectIntl
export default class Table extends Component {
    static propTypes = {
        annotationsTableChange: PropTypes.func.isRequired,
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        rows: PropTypes.array,
        sorted: PropTypes.array,
    }

    handleTableChange = (changeData) => {
        const { block, id, level, module, customData, annotationsTableChange } = this.props

        annotationsTableChange(module, block, id, level, customData, changeData)
    }

    renderSubComponent = (row) => (
        <div className={'annotations-sub-row'}>
            <span>{_.get(row, 'row.row.text', '')}</span>
        </div>
    )

    render() {
        const { id, intl, isLoading, pagination, sorted, rows } = this.props

        if (_.isEmpty(rows)) return null

        return (
            <div className={'annotations-table-container'}>
                <FilterTable
                    id={`annotations-table-${id}`}
                    itemIdentifier={'id'}
                    loading={isLoading}
                    data={rows ?? []}
                    columnsDefinition={[
                        {
                            accessor: 'category',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.category` }),
                            width: 150,
                        },
                        {
                            accessor: 'text',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.annotation` }),
                        },
                        {
                            accessor: 'source',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.source` }),
                            width: 150,
                        },
                        {
                            accessor: 'publicationDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.published` }),
                            Cell: (value) => (
                                <CustomDate
                                    date={_.get(value, 'value.value', null)}
                                    precision={_.get(value, 'value.precision', null)}
                                />
                            ),
                            sortable: true,
                            width: 125,
                        },
                    ]}
                    settings={{
                        pagination,
                        sorted,
                    }}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                    }}
                    onTableChange={this.handleTableChange}
                    SubComponent={this.renderSubComponent}
                    expandOnRowClick
                />
            </div>
        )
    }
}
